<template>
  <v-app>
    <v-main>
      <SnackbarError v-model="statuses.errorOnSnackbar" :message="statuses.errorMessage" />
      <v-fade-transition mode="out-in" >
        <router-view v-if="!loading"></router-view>
      </v-fade-transition>
      <v-overlay :value="loading" absolute>
        <div class="loading text-center">
          <div class="text-center mb-4">Aguarde enquanto carregamos os dados...</div>
          <v-progress-circular indeterminate size="64" color="primary" />
        </div>
      </v-overlay>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import cadastroService from '@/services/cadastro'
import SnackbarError from '@/components/common/SnackbarError'

function setFavicon(href) {
  if (!href) return
  const head = document.head || document.getElementsByTagName('head')[0]
  let link = head.querySelector("link[rel~='icon']")
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    head.appendChild(link)
  }
  link.href = href
}

export default {
  name: 'App',
  components: {
    SnackbarError,
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapGetters('layout', ['statuses']),
    ...mapGetters('customizacao', ['faviconUrl']),
  },
  methods: {
    ...mapMutations('customizacao', ['setCustomizacao']),
    ...mapMutations('cadastro', ['setActualStep']),
    async loadCustomizacaoFromRoute() {
      const token = this.$route?.params?.token
      if (!token) return
      try {
        this.loading = true
        const encodedToken = encodeURIComponent(token)
        const { data } = await cadastroService.getCustomizacao(encodedToken)
        this.setCustomizacao({
          url_logo: data.url_logo,
          url_logo_inverse: data.url_logo_inverse,
          color_theme: data.color_theme,
          name: data.name,
          tipo_faturamento: data.tipo_faturamento,
          email_faturamento: data.email_faturamento,
          cnpj_pagador: data.cnpj_pagador,
        })

        // Favicon acompanha a customização (fallback: url_logo)
        setFavicon(data.url_favicon || data.url_logo)

        if (data.tipo_faturamento === 'parceiro' && this.$route?.name === 'cadastro-faturamento') {
          this.setActualStep(6)
          this.$router.replace({ name: 'cadastro-contrato' })
        }
      } catch (error) {
        // mantém defaults em caso de erro
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    '$route.params.token': {
      immediate: true,
      handler() {
        this.loadCustomizacaoFromRoute()
      },
    },
    faviconUrl: {
      immediate: true,
      handler(value) {
        // Permite atualizar o favicon se a customização vier por outro caminho
        setFavicon(value)
      },
    },
  },
}
</script>
